import styled from "styled-components";
import { Link } from "react-router-dom";
import { sizes } from "../01_config/Sizes";

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    height: ${sizes.headerheight};
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    z-index: 130;
    padding: 0 ${sizes.margins_desk};
    gap: 30px;
    @media(max-width: 800px) {
        padding: 0 ${sizes.marginmobile};
        height: ${sizes.headerhight_mobile}
    }
`
const LogoWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 25px;
    @media(max-width: 800px) {
        gap: 5px;
    }
`

const CountryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
`

const CountryText = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const CountryImage = styled.img`
    position: relative;
    width: 25px;
`

const NavWrapper = styled.div`
    display: flex;
`

const MenuWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5vw;
    @media(max-width: 1300px) {
        gap: 8px;
    }
    @media(max-width: 1200px) {
        display: ${({ hambMenu }) => hambMenu ? "flex" : "none"};
        gap: 0;
        position: absolute;
        top: ${sizes.headerheight};
        right: 0;
        width: 150px;
        flex-direction: column;
    }
    @media(max-width: 800px) {
        top: ${sizes.headerhight_mobile}
    }
`

const MenuItem = styled(Link)`
    font-weight: bold;
    font-size: 0.8rem;
    text-decoration: none;
    color: black;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -ms-user-select: none;
    @media(max-width: 1200px) {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        padding-left: 5px;
        border-bottom: gray solid 1px;
        background-color: lightgray;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
    }
    @media(max-width: 800px) {
        display: flex;
        justify-content: center;
    }
`

const Logo = styled(MenuItem)`
    // margin-left: ${sizes.margins_desk};
    font-family: "Rammetto One";
    font-size: 3vw;
    font-size: calc(12px + 2vw);
    font-weight: 200;
    display: flex;
    align-items: center;
    cursor: pointer;
        @media(max-width: 1000px) {
        background-color: white; 
        border-bottom: none;
    }
    @media(max-width: 800px) {
        justify-content: left;
    }
`

const HambWrapper = styled.div`
    position: absolute;
    cursor: pointer;
    top: 0;
    height: fit-content;
    font-size: 30px;
    display: none;
    @media (max-width: 1200px) {
        height: 100%;
        display: flex;
        align-items: center;
        // right: calc(40px + ${sizes.sections_mob_marginsides})
    }
    @media(max-width: 800px) {
            right: calc(20px + ${sizes.margins_desk})
    }
`

const FullScreenWrapper = styled.div`
            @media (max-width: 1200px) {
        top: 0;
        left: 0;
        position: absolute;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0.1);
        display: ${({hambMenu}) => hambMenu ? "block" : "none" };
}
`

export { Wrapper, LogoWrapper, CountryWrapper, CountryText, CountryImage, Logo, NavWrapper, MenuWrapper, MenuItem, HambWrapper, FullScreenWrapper }